import { usePageHeader } from "contexts/PageHeaderContext";
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { Button } from '../../../ui/button';
import { InputFieldset } from 'ui/inputFieldset';
import { SelectFieldset } from 'ui/selectFieldset';
import { SelectTriggerUI } from 'ui/selectTrigger';
import { PopoverTriggerUI } from 'ui/popoverTrigger';
import { Label } from '../../../ui/label';
import { Badge } from '../../../ui/badge';
import { Switch } from '../../../ui/switch';
import { Select, SelectContent, SelectItem, SelectValue } from '../../../ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../ui/table';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from '../../../components/ui/command';
import {
  Calendar,
  Plus,
  Edit2,
  Trash2,
  Users,
  ChevronDown,
  ChevronRight,
  Check,
  ChevronsUpDown,
  Activity,
} from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { AllocationPayload, CreateRotationPayload, FormData, FormErrors, LawazimType, Rotation, RotationApi, RotationErrors, RotationForm, SelectedTourOperator, TourOperatorApi, TransportCharges, UpdateMiqaatPayload, UpdateRotationPayload } from '../../../types/miqaatConfig';
import { createUpdateQuota, createRotation, getLawazimTypesList, getMiqaatByPublicId, getTourOperatorsForMiqaat, updateRotation, updateMiqaat } from 'services/miqaatConfigService';
import { FullScreenLoading } from 'components/ui/loader';
import { AxiosError } from 'axios';
import { toast } from 'sonner';
import { useScreenPermission } from 'hooks/useScreenPermission';
import { ActivityLogsPage } from 'pages/muwafiqa/completed/ActivityLogsPage';
import { getStatusHistory } from 'services/visaService';
import { StatusHistory } from 'types/visa';
import { allowOnlyNumbers } from 'utils/commonutils';


interface Lawazim {
  id: string;
  chargeName: string;
  chargeType: 'daily-rate' | 'fixed-rate';
  accommodationIncluded: boolean;
  mawaidIncluded: boolean;
  transportIncluded: boolean;
  atrafIncluded: boolean;
  infantPrice: number;
  childPrice: number;
  adultPrice: number;
  seniorPrice: number;
  // Extra charges for additional nights (only for fixed-rate)
  extraAccommodationFaizSenior?: number;
  extraAccommodationFaizAdult?: number;
  extraAccommodationFaizChild?: number;
  extraAccommodationFaizInfant?: number;
  extraAccommodationHotelSenior?: number;
  extraAccommodationHotelAdult?: number;
  extraAccommodationHotelChild?: number;
  extraAccommodationHotelInfant?: number;
  extraZiyaratTransportSenior?: number;
  extraZiyaratTransportAdult?: number;
  extraZiyaratTransportChild?: number;
  extraZiyaratTransportInfant?: number;
  // Transport configuration - array of charges for all ports
  arrivalCharges: TransportCharges[];
  departureCharges: TransportCharges[];
}


export function EditMiqaatConfiguration() {

  const { id } = useParams();
  const navigate = useNavigate()
  const { setPageHeader } = usePageHeader();
  useEffect(() => {
    setPageHeader({
      title: 'Edit Miqaat',
      childTitle: 'Update miqaat details and configuration',
      icon: <Calendar className="h-5 w-5" />,
      onBack: () => { navigate(-1) },
    });
    return () => setPageHeader(null);
  }, [setPageHeader, navigate]);
  const { canEdit } = useScreenPermission();
  const [loading, setLoading] = useState(false);
  const [available_Lawazim, setAvailable_lawazim] = useState<LawazimType[]>([])
  const [availableTourOperators, setAvailableTourOpeartors] = useState<TourOperatorApi[]>([])
  // State for Lawazim
  const [lawazimList, setLawazimList] = useState<Lawazim[]>([]);


  // State for Rotations
  const [rotations, setRotations] = useState<Rotation[]>([]);
  const [expandedRotations, setExpandedRotations] = useState<string[]>(['1']); // Track expanded rotations
  const [showRotationDialog, setShowRotationDialog] = useState(false);
  const [editingRotationId, setEditingRotationId] = useState<string | null>(null);


  const [showActivityLogs, setShowActivityLogs] = useState(false);
  const [selectedApplicantForLogs, setSelectedApplicantForLogs] = useState<StatusHistory[]>([]);
  const [statushisLoader, setStatusHistoryLoader] = useState<boolean>(false);


  // Tour Operator Assignment in Dialog
  // const [tourOperatorSearch, setTourOperatorSearch] = useState('');
  const [selectedTourOperatorId, setSelectedTourOperatorId] = useState('');
  const [allocatedQuota, setAllocatedQuota] = useState(0);
  const [tourOperatorError, setTourOperatorError] = useState('');
  const [quotaError, setQuotaError] = useState('');

  const [tempTourOperators, setTempTourOperators] = useState<SelectedTourOperator[]>([]);
  const [comboboxOpen, setComboboxOpen] = useState(false);
  const [editingQuotaId, setEditingQuotaId] = useState<string | null>(null);
  const [dialogMode, setDialogMode] = useState<'add-quota' | 'edit-rotation'>('add-quota');
  const [refatch, setReFatch] = useState(false)

  // Delete confirmation dialogs
  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState<{
    open: boolean;
    type: 'lawazim' | 'tour-operator';
    id: string;
    rotationId?: string;
    name?: string;
  }>({ open: false, type: 'lawazim', id: '' });

  const [errors, setErrors] = useState<FormErrors>({});
  const [formData, setFormData] = useState<FormData>({
    miqaatName: '',
    miqaatCode: '',
    cutoffDays: 30,
    totalPaxLimit: 0,
    razaPackage: false,
    isActive: false,
    itsMiqaatId: '',
  });

  const [rotationErrors, setRotationErrors] = useState<RotationErrors>({});
  const [rotationForm, setRotationForm] = useState<RotationForm>({
    miqaatId: "",
    rotationId: "",
    rotationName: "",
    arrivalDate: "",
    departureDate: "",
    quota: 0,
    maxDaysAllowed: 0,
    lawazimId: "",
  });


  // GET LAWAZIM DD LIST
  const getLawazimListApi = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getLawazimTypesList();
      setAvailable_lawazim(data)
    } catch {
      toast.error("Failed to fetch venues");
    } finally {
      setLoading(false);
    }
  }, []);


  const getTourOperatorListApi = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getTourOperatorsForMiqaat();
      setAvailableTourOpeartors(data)
    } catch {
      toast.error("Failed to fetch venues");
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    getLawazimListApi()
    getTourOperatorListApi()
  }, [getLawazimListApi, getTourOperatorListApi]);


  // PREFILLED API DATA
  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getMiqaatByPublicId(id);


        // ✅ Set basic form data
        setFormData({
          miqaatName: data.miqaatName,
          miqaatCode: data.miqaatCode,
          cutoffDays: data.cutoffDays,
          totalPaxLimit: data.totalPaxLimit,
          razaPackage: data.requireRaza,
          isActive: data.isActive,
          itsMiqaatId: data.miqaatId || "",
        });

        // ✅ Set rotations
        const formattedRotations = data.rotations.map((rot: RotationApi) => ({
          id: rot.publicId,
          miqaatId: rot?.itsMiqaatId || data.miqaatId?.toString() || "",
          rotationId: rot.rotationCode,
          rotationName: rot.rotationName,
          arrivalDate: rot.arrivalDate.split("T")[0], // date format fix
          departureDate: rot.departureDate.split("T")[0],
          quota: rot.quota,
          maxDaysAllowed: 0,
          // lawazimId: rot.lawazimFeeConfigId,
          lawazimId: rot.lawazimId,
          tourOperators: rot.allocations.map((alloc, index) => ({
            id: `${index}`,
            operatorId: String(alloc.tourOperatorId),
            operatorName: alloc.tourOperatorName,
            office: alloc.officeName,
            itsNumber: "",
            allocatedQuota: alloc.allocatedQuota,
            rotationId: rot.publicId,
          })),
        }));

        setRotations(formattedRotations);

      } catch (error) {
        console.error("Error fetching miqaat", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, refatch]);
  // PREFILLED API DATA



  // Toggle rotation expansion
  const toggleRotationExpansion = (rotationId: string) => {
    setExpandedRotations((prev) =>
      prev.includes(rotationId) ? prev.filter((id) => id !== rotationId) : [...prev, rotationId]
    );
  };

  // Toggle miqaat row expansion in list view
  // const handleDeleteLawazim = (id: string) => {
  //   const lawazim = lawazimList.find(l => l.id === id);
  //   setDeleteConfirmDialog({
  //     open: true,
  //     type: 'lawazim',
  //     id,
  //     name: lawazim?.chargeName,
  //   });
  // };

  const confirmDelete = () => {
    if (deleteConfirmDialog.type === 'lawazim') {
      setLawazimList(lawazimList.filter((item) => item.id !== deleteConfirmDialog.id));
    } else if (deleteConfirmDialog.type === 'tour-operator' && deleteConfirmDialog.rotationId) {
      handleRemoveTourOperator(deleteConfirmDialog.rotationId, deleteConfirmDialog.id);
    }
    setDeleteConfirmDialog({ open: false, type: 'lawazim', id: '' });
  };

  // Rotation Dialog handlers
  const openRotationDialog = (rotation: Rotation, mode: 'add-quota' | 'edit-rotation') => {
    setRotationForm({
      miqaatId: rotation.miqaatId,
      rotationId: rotation.rotationId,
      rotationName: rotation.rotationName,
      arrivalDate: rotation.arrivalDate,
      departureDate: rotation.departureDate,
      quota: rotation.quota,
      maxDaysAllowed: rotation.maxDaysAllowed,
      lawazimId: rotation.lawazimId,
    });
    setTempTourOperators([...rotation.tourOperators]);
    setEditingRotationId(rotation.id);
    setDialogMode(mode);
    setShowRotationDialog(true);
  };


  // ADD & UPDATE QUOTAS START
  const handleAddTourOperatorInDialog = async () => {
    let valid = true;

    setTourOperatorError('');
    setQuotaError('');

    if (!selectedTourOperatorId) {
      setTourOperatorError('Please select a tour operator');
      valid = false;
    }

    if (allocatedQuota <= 0) {
      setQuotaError('Please enter a valid quota');
      valid = false;
    }

    // ✅ Calculate remaining quota
    let currentAllocated = 0;
    if (editingQuotaId) {
      // EXCLUDE current editing item
      currentAllocated = tempTourOperators
        .filter((to) => to.id !== editingQuotaId)
        .reduce((sum, to) => sum + to.allocatedQuota, 0);
    } else {
      currentAllocated = tempTourOperators.reduce(
        (sum, to) => sum + to.allocatedQuota,
        0
      );
    }
    const remainingQuota = rotationForm.quota - currentAllocated;
    // VALIDATION
    if (allocatedQuota > remainingQuota) {
      setQuotaError(`Only ${remainingQuota} quota remaining`);
      // toast.error(`Only ${remainingQuota} quota remaining`);
      toast.error(`Cannot allocate ${allocatedQuota}. Available quota: ${remainingQuota}`);
      return;
    }

    if (!valid) return;

    let updatedOperators: SelectedTourOperator[] = [];

    if (editingQuotaId) {
      const currentAllocated = tempTourOperators
        .filter((to) => to.id !== editingQuotaId)
        .reduce((sum, to) => sum + to.allocatedQuota, 0);

      if (currentAllocated + allocatedQuota > rotationForm.quota) {
        setQuotaError(`Available quota: ${rotationForm.quota - currentAllocated}`);
        return;
      }

      updatedOperators = tempTourOperators.map((to) =>
        to.id === editingQuotaId ? { ...to, allocatedQuota } : to
      );

      setEditingQuotaId(null);
    } else {
      const currentAllocated = tempTourOperators.reduce(
        (sum, to) => sum + to.allocatedQuota,
        0
      );

      if (currentAllocated + allocatedQuota > rotationForm.quota) {
        setQuotaError(`Available quota: ${rotationForm.quota - currentAllocated}`);
        return;
      }

      const operator = availableTourOperators.find(
        (op) => String(op.tourOperatorId) === selectedTourOperatorId
      );

      if (!operator) return;

      if (tempTourOperators.some((to) => to.itsNumber === operator.itsNumber)) {
        setTourOperatorError(
          'This tour operator is already assigned to this rotation'
        );
        return;
      }

      const newTourOperator: SelectedTourOperator = {
        id: Date.now().toString(),
        operatorId: String(operator.tourOperatorId),
        operatorName: operator.firstName,
        office: operator.officeName,
        itsNumber: operator.itsNumber,
        allocatedQuota: allocatedQuota,
        rotationId: editingRotationId || '',
      };

      updatedOperators = [...tempTourOperators, newTourOperator];
    }

    // UPDATE UI FIRST
    setTempTourOperators(updatedOperators);

    // ---------------- API CALL ----------------
    try {
      const payload: AllocationPayload = {
        rotationPublicId: editingRotationId || '',
        allocations: updatedOperators.map((to) => ({
          tourOperatorId: Number(to.operatorId),
          allocatedQuota: to.allocatedQuota,
          tourOperatorName: to.operatorName,
          officeName: to.office,
        })),
      };

      await createUpdateQuota(payload);
      setReFatch(!refatch)
      toast.success("Quota updated successfully");

    } catch (err: unknown) {
      let errorMessage = "Failed to update quota";

      if (err instanceof AxiosError) {
        const data = err.response?.data as { message?: string };
        errorMessage = data?.message || err.message;
      }

      toast.error(errorMessage);
    }
    // RESET INPUTS
    setSelectedTourOperatorId('');
    setAllocatedQuota(0);
  };
  // ADD & UPDATE QUOTAS END



  // const handleRemoveTourOperatorFromDialog = (id: string) => {
  //   setTempTourOperators(tempTourOperators.filter((to) => to.id !== id));
  // };


  // ROTATION VALIDATION FUNCTION START
  const handleRotationFieldChange = <K extends keyof RotationForm>(
    field: K,
    value: RotationForm[K]
  ) => {
    // SET ROTATION FORM FIELD VALUE
    setRotationForm((prev) => ({ ...prev, [field]: value }));
    // ROTATION ERROR MSG RESET
    if (value) {
      setRotationErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateRotation = () => {
    const newErrors: RotationErrors = {};

    if (formData.razaPackage && !rotationForm.miqaatId) {
      newErrors.miqaatId = "ITS Miqaat ID is required";
    }

    if (!rotationForm.rotationId) {
      newErrors.rotationId = "Rotation ID is required";
    }

    if (!rotationForm.rotationName) {
      newErrors.rotationName = "Rotation Name is required";
    }

    if (!rotationForm.arrivalDate) {
      newErrors.arrivalDate = "Arrival date is required";
    }

    if (!rotationForm.departureDate) {
      newErrors.departureDate = "Departure date is required";
    }

    if (!rotationForm.quota || rotationForm.quota <= 0) {
      newErrors.quota = "Quota must be greater than 0";
    }

    if (!rotationForm.lawazimId) {
      newErrors.lawazimId = "Please select a Lawazim";
    }
    setRotationErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ADD ROTATIONS
  const resetRotationForm = () => {
    setRotationForm({
      miqaatId: '',
      rotationId: '',
      rotationName: '',
      arrivalDate: '',
      departureDate: '',
      quota: 0,
      maxDaysAllowed: 0,
      lawazimId: '',
    });
  };



  const handleAddRotation = async () => {
    if (!validateRotation()) return;
    try {
      const payload: CreateRotationPayload = {
        miqaatPublicId: id, // from useParams
        its_MiqaatId: rotationForm.miqaatId,
        rotationCode: rotationForm.rotationId,
        rotationName: rotationForm.rotationName,
        arrivalDate: new Date(rotationForm.arrivalDate).toISOString(),
        departureDate: new Date(rotationForm.departureDate).toISOString(),
        quota: Number(rotationForm.quota),
        // lawazimFeeConfigId: Number(rotationForm.lawazimId),
        lawazimId: Number(rotationForm.lawazimId),
      };

      const res = await createRotation(payload);

      // ✅ Update UI after API success
      const newRotation: Rotation = {
        id: res?.publicId || Date.now().toString(),
        miqaatId: rotationForm.miqaatId,
        rotationId: rotationForm.rotationId,
        rotationName: rotationForm.rotationName,
        arrivalDate: rotationForm.arrivalDate,
        departureDate: rotationForm.departureDate,
        quota: rotationForm.quota,
        maxDaysAllowed: rotationForm.maxDaysAllowed,
        lawazimId: rotationForm.lawazimId,
        tourOperators: [],
      };
      setRotations(prev => [...prev, newRotation]);
      toast.success("Rotation added successfully");
      // ✅ Reset form
      resetRotationForm()
    } catch (err: unknown) {
      let errorMessage = "Failed to add rotation";

      if (err instanceof AxiosError) {
        const data = err.response?.data as { message?: string };
        errorMessage = data?.message || err.message;
      }

      toast.error(errorMessage);
    }
  };
  // ROTATION VALIDATION FUNCTION END


  const handleSaveRotation = async () => {

    if (!rotationForm.rotationName || !rotationForm.rotationId) {
      toast.error('Please enter Rotation ID and Rotation Name')
      return;
    }
    if (formData.razaPackage && !rotationForm.miqaatId) {
      toast.error('Please enter ITS Miqaat ID')
      return;
    }
    if (!rotationForm.lawazimId) {
      toast.error('Please select a Lawazim');
      return;
    }

    try {
      const payload: UpdateRotationPayload = {
        rotationPublicId: String(editingRotationId), //  IMPORTANT
        its_MiqaatId: rotationForm.miqaatId,
        rotationCode: rotationForm.rotationId,
        rotationName: rotationForm.rotationName,
        arrivalDate: new Date(rotationForm.arrivalDate).toISOString(),
        departureDate: new Date(rotationForm.departureDate).toISOString(),
        quota: Number(rotationForm.quota),
        // lawazimFeeConfigId: Number(rotationForm.lawazimId),
        lawazimId: Number(rotationForm.lawazimId),

        // ✅ allocations
        allocations: tempTourOperators.map((to) => ({
          tourOperatorId: Number(to.operatorId),
          allocatedQuota: to.allocatedQuota,
          tourOperatorName: to.operatorName,
          officeName: to.office,
        })),
      };

      await updateRotation(payload);

      // ✅ Update UI after success
      const updatedRotation: Rotation = {
        id: String(editingRotationId),
        publicId: String(editingRotationId),
        miqaatId: rotationForm.miqaatId,
        rotationId: rotationForm.rotationId,
        rotationName: rotationForm.rotationName,
        arrivalDate: rotationForm.arrivalDate,
        departureDate: rotationForm.departureDate,
        quota: rotationForm.quota,
        maxDaysAllowed: rotationForm.maxDaysAllowed,
        lawazimId: rotationForm.lawazimId,
        tourOperators: tempTourOperators,
      };

      setRotations((prev) =>
        prev.map((item) =>
          item.id === editingRotationId ? updatedRotation : item
        )
      );

      toast.success("Rotation updated successfully");
      setReFatch(!refatch)
      resetRotationForm()
      setShowRotationDialog(false);
      setEditingRotationId(null);

    } catch (err: unknown) {
      let errorMessage = "Failed to update rotation";
      if (err instanceof AxiosError) {
        const data = err.response?.data as { message?: string };
        errorMessage = data?.message || err.message;
      }
      toast.error(errorMessage);
    }
  };



  // const handleDeleteRotation = (id: string) => {
  //   if (rotations.length === 1) {
  //     alert('Cannot delete the last rotation');
  //     return;
  //   }
  //   setRotations(rotations.filter((item) => item.id !== id));
  // };

  const handleRemoveTourOperator = (rotationId: string, tourOperatorId: string) => {
    setRotations(
      rotations.map((r) =>
        r.id === rotationId
          ? { ...r, tourOperators: r.tourOperators.filter((to) => to.id !== tourOperatorId) }
          : r
      )
    );
  };



  // UPDATE MIQAAT VALIDATION FUNCTION
  const validateForm = () => {
    const newErrors: FormErrors = {};
    if (!formData.miqaatName.trim()) {
      newErrors.miqaatName = "Miqaat name is required";
    }
    if (!formData.miqaatCode.trim()) {
      newErrors.miqaatCode = "Miqaat code is required";
    }
    if (formData.cutoffDays <= 0) {
      newErrors.cutoffDays = "Cutoff days must be greater than 0";
    }
    if (formData.totalPaxLimit <= 0) {
      newErrors.totalPaxLimit = "Total pax limit is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  //UPDATE MIQAAT FUNCTION 
  const handleSubmit = async () => {
    const isValid = validateForm();
    if (!isValid) return;

    try {
      const payload: UpdateMiqaatPayload = {
        publicId: String(id), // ✅ MUST have this
        miqaatId: Number(formData.itsMiqaatId || 0),
        miqaatCode: formData.miqaatCode,
        miqaatName: formData.miqaatName,
        // description: formData.description,
        cutoffDays: Number(formData.cutoffDays),
        totalPaxLimit: Number(formData.totalPaxLimit),
        requireRaza: formData.razaPackage,
        isActive: formData.isActive,
        updatedBy: 0,
      };

      // console.log("UPDATE PAYLOAD 👉", payload);
      // console.log("UPDATE RESPONSE 👉", res);

      await updateMiqaat(payload);
      toast.success("Miqaat updated successfully");

      navigate("/miqaat-master");
    } catch (err: unknown) {
      let errorMessage = "Failed to update miqaat";
      if (err instanceof AxiosError) {
        const data = err.response?.data as { message?: string };
        errorMessage = data?.message || err.message;
      }
      toast.error(errorMessage);
    }
  };



  const handleViewHistory = async (rotationId: string) => {
    // console.log('View history for rotation:', rotationId);
    toast.info(`History feature coming soon! ${rotationId}`);
    setShowActivityLogs(true);
    try {
      setStatusHistoryLoader(true);
      const data = await getStatusHistory(123);
      if (data?.length > 0) {
        setSelectedApplicantForLogs(data);
        setShowActivityLogs(true);
      } else {
        toast.info('No history available for this rotation.');
      }
    } catch (error) {
      console.error("Error fetching rotation history:", error);
      toast.error('Failed to fetch history.');
    } finally {
      setStatusHistoryLoader(false);
    }
  };


  // FORM VIEW
  return (
    <div className="space-y-4 pb-6">
      {loading && <FullScreenLoading />}
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-4">

        {/* Action Buttons */}
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={() => { navigate(-1) }}
            className="h-9"
          >
            Cancel
          </Button>
          {canEdit && (
            <Button
              onClick={handleSubmit}
              style={{ background: '#5B9BD5' }}
              className="text-white h-9 px-8"
            >
              {'Update Miqaat'}
            </Button>
          )}


          {/* REMOVE THIS HIDDEN DIV IT IS JUST TO REMOVE TS ERRORS */}
          {/* <div className='hidden'>
            <Button
              onClick={() => { handleDeleteLawazim('123') }}
              className="text-white h-9 px-8"
            >
              {'test button'}
            </Button>
          </div> */}
          {/* REMOVE THIS HIDDEN DIV IT IS JUST TO REMOVE TS ERRORS */}

        </div>
      </div>

      {/* Basic Information Card */}
      <Card className="bg-white border-[#5B9BD5]/20 shadow-md">
        <CardHeader style={{ backgroundColor: '#E3F2FD' }} className="pb-3">
          <CardTitle className="text-gray-900 text-base">Basic Information</CardTitle>
        </CardHeader>
        <CardContent className="p-4 sm:p-5">
          <div className="space-y-5">
            {/* Miqaat Name & Code */}
            <div>
              <h3 className="text-sm mb-3" style={{ color: '#5B9BD5' }}>Miqaat Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <InputFieldset
                    label="Miqaat Name"
                    required
                    id="miqaatName"
                    placeholder="Enter miqaat name..."
                    value={formData.miqaatName}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({ ...formData, miqaatName: value });
                      if (value.trim()) {
                        setErrors({ ...errors, miqaatName: undefined });
                      }
                    }}
                    className="bg-white border-gray-200"
                  />
                  {errors.miqaatName && (
                    <p className="text-red-500 text-xs mt-1">{errors.miqaatName}</p>
                  )}
                </div>
                <div className="space-y-1.5">
                  <InputFieldset
                    label="Miqaat Code"
                    id="miqaatCode"
                    placeholder="e.g., MQT-2025-001"
                    value={formData.miqaatCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({ ...formData, miqaatCode: value });
                      if (value.trim()) {
                        setErrors({ ...errors, miqaatCode: undefined });
                      }
                    }}
                    className="bg-white border-gray-200"
                  />
                  {errors.miqaatCode && (
                    <p className="text-red-500 text-xs mt-1">{errors.miqaatCode}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Cutoff Days, Post Cutoff Days, Total Pax Limit - All in one row */}
            <div>
              <h3 className="text-sm mb-3" style={{ color: '#5B9BD5' }}>Validity Period</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <InputFieldset
                    label="Cutoff Days"
                    id="cutoffDays"
                    type="text"
                    value={formData.cutoffDays}
                    onChange={(e) => {
                      const value = allowOnlyNumbers(e.target.value);
                      setFormData({ ...formData, cutoffDays: parseInt(value) || 0 });
                      if (value.trim()) {
                        setErrors({ ...errors, cutoffDays: undefined });
                      }
                    }}
                    className="bg-white border-gray-200"
                  />
                  {errors.cutoffDays && (
                    <p className="text-red-500 text-xs mt-1">{errors.cutoffDays}</p>
                  )}
                </div>
                <div className="space-y-1.5">
                  <InputFieldset
                    label="Total Pax Limit"
                    required
                    id="totalPaxLimit"
                    type="text"
                    value={formData.totalPaxLimit}
                    onChange={(e) => {
                      const value = allowOnlyNumbers(e.target.value);
                      setFormData({ ...formData, totalPaxLimit: parseInt(value) || 0 });
                      if (value.trim()) {
                        setErrors({ ...errors, totalPaxLimit: undefined });
                      }
                    }}
                    className="bg-white border-gray-200"
                  />
                  {errors.totalPaxLimit && (
                    <p className="text-red-500 text-xs mt-1">{errors.totalPaxLimit}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Toggles - Require Raza & Is Active */}
            <div>
              <h3 className="text-sm mb-3" style={{ color: '#5B9BD5' }}>Settings</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Require Raza Toggle */}
                <div className="bg-input-background flex items-center justify-between p-3 bg-white rounded border border-gray-200">
                  <div className="space-y-0.5">
                    <Label className="text-sm text-gray-900">Require Raza</Label>
                    <p className="text-xs text-gray-500">Requires Raza validation via ITS API</p>
                  </div>
                  <Switch
                    checked={formData.razaPackage}
                    onCheckedChange={(checked) => setFormData({ ...formData, razaPackage: checked })}
                    className="data-[state=checked]:bg-[#5B9BD5]"
                  />
                </div>

                {/* Is Active Toggle */}
                <div className="bg-input-background flex items-center justify-between p-3 bg-white rounded border border-gray-200">
                  <div className="space-y-0.5">
                    <Label className="text-sm text-gray-900">Is Active</Label>
                    <p className="text-xs text-gray-500">Activate this miqaat package</p>
                  </div>
                  <Switch
                    checked={formData.isActive}
                    onCheckedChange={(checked) => setFormData({ ...formData, isActive: checked })}
                    className="data-[state=checked]:bg-[#5B9BD5]"
                  />
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Rotation Management Card - Only show when editing */}
      <Card className="bg-white border-[#5B9BD5]/20 shadow-md">
        <CardHeader style={{ backgroundColor: '#E3F2FD' }} className="pb-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#5B9BD5] flex items-center justify-center">
              <Calendar className="w-5 h-5 text-white" />
            </div>
            <div>
              <CardTitle className="text-gray-900 text-base">Rotation Management</CardTitle>
              <p className="text-xs text-gray-600 mt-0.5">Configure rotations with arrival/departure dates and quotas</p>
            </div>
          </div>
        </CardHeader>
        <CardContent className="p-4 sm:p-5">
          <div className="space-y-4">
            {/* Add Rotation Form */}
            <Card className="bg-white border-[#5B9BD5]/30 shadow-sm bg-gray-50">
              <CardContent className="p-4">
                <div className="space-y-4">
                  {/* Row 1: ITS Miqaat ID (if raza), Rotation ID, Rotation Name */}
                  <div className={`grid grid-cols-1 gap-4 ${formData.razaPackage ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}>
                    {formData.razaPackage && (
                      <div className="space-y-1.5">
                        <InputFieldset
                          label="ITS Miqaat ID"
                          required
                          id="newMiqaatId"
                          placeholder="e.g., GEN"
                          value={rotationForm.miqaatId}
                          onChange={(e) => handleRotationFieldChange("miqaatId", e.target.value)}
                          className="g-white border-gray-200"
                        />
                        {rotationErrors.miqaatId && (
                          <p className="text-red-500 text-xs">{rotationErrors.miqaatId}</p>
                        )}
                      </div>
                    )}
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Rotation ID"
                        required
                        id="newRotationId"
                        placeholder="e.g., R-GEN-001"
                        value={rotationForm.rotationId}
                        onChange={(e) => handleRotationFieldChange("rotationId", e.target.value)}
                        className="bg-white border-gray-200"
                      />
                      {rotationErrors.rotationId && (
                        <p className="text-red-500 text-xs">{rotationErrors.rotationId}</p>
                      )}
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Rotation Name"
                        required
                        id="newRotationName"
                        placeholder="e.g., General"
                        value={rotationForm.rotationName}
                        onChange={(e) => handleRotationFieldChange("rotationName", e.target.value)}
                        className="bg-white border-gray-200"
                      />
                      {rotationErrors.rotationName && (
                        <p className="text-red-500 text-xs">{rotationErrors.rotationName}</p>
                      )}
                    </div>
                  </div>

                  {/* Row 2: Arrival Date, Departure Date, Quota, Lawazim */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Arrival Date"
                        id="newArrivalDate"
                        type="date"
                        value={rotationForm.arrivalDate}
                        onChange={(e) => handleRotationFieldChange("arrivalDate", e.target.value)}
                        className="bg-white border-gray-200"
                      />
                      {rotationErrors.arrivalDate && (
                        <p className="text-red-500 text-xs">{rotationErrors.arrivalDate}</p>
                      )}
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Departure Date"
                        id="newDepartureDate"
                        type="date"
                        value={rotationForm.departureDate}
                        onChange={(e) => handleRotationFieldChange("departureDate", e.target.value)}
                        className="bg-white border-gray-200"
                      />
                      {rotationErrors.departureDate && (
                        <p className="text-red-500 text-xs">{rotationErrors.departureDate}</p>
                      )}
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Quota"
                        required
                        id="newQuota"
                        type="text"
                        placeholder="0"
                        value={rotationForm.quota}
                        onChange={(e) => {
                          const value = allowOnlyNumbers(e.target.value);
                          handleRotationFieldChange("quota", parseInt(value) || 0);
                        }}
                        className="bg-white border-gray-200"
                      />
                      {rotationErrors.quota && (
                        <p className="text-red-500 text-xs">{rotationErrors.quota}</p>
                      )}
                    </div>
                    <div className="space-y-1.5">
                      {/* <SelectFieldset label="Lawazim" required>
                        <Select value={rotationForm.lawazimId}
                          onValueChange={(value) => handleRotationFieldChange("lawazimId", value)}
                        >
                          <SelectTriggerUI className="bg-input-background h-6 bg-white border-gray-200">
                            <SelectValue placeholder="Select Lawazim" />
                          </SelectTriggerUI>
                          <SelectContent>
                            {available_Lawazim.map((lawazim) => (
                              <SelectItem key={lawazim.id} value={String(lawazim?.publicId)}>
                                {lawazim?.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </SelectFieldset>
                      {rotationErrors.lawazimId && (
                        <p className="text-red-500 text-xs">{rotationErrors.lawazimId}</p>
                      )} */}

                      <SelectFieldset label="Lawazim" required>
                        <Select value={rotationForm.lawazimId}
                          onValueChange={(value) => handleRotationFieldChange("lawazimId", value)}
                        >
                          <SelectTriggerUI className="bg-input-background h-6 bg-white border-gray-200">
                            <SelectValue placeholder="Select Lawazim" />
                          </SelectTriggerUI>
                          <SelectContent>
                            {available_Lawazim.map((lawazim) => (
                              <SelectItem key={lawazim.id} value={String(lawazim.id)}>
                                {/* {lawazim.lawazimName} ({lawazim.code}) */}
                                {lawazim?.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </SelectFieldset>
                      {rotationErrors.lawazimId && (
                        <p className="text-red-500 text-xs">{rotationErrors.lawazimId}</p>
                      )}
                    </div>
                  </div>

                  {/* Add Rotation Button */}
                  <div className="flex justify-end">
                    <Button
                      onClick={handleAddRotation}
                      style={{ background: '#5B9BD5' }}
                      className="text-white h-9"
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Add Rotation
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Rotations Table - Desktop */}
            <div className="hidden lg:block border border-gray-200 rounded overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow className="bg-blue-50">
                    <TableHead className="text-[#5B9BD5] w-10"></TableHead>
                    <TableHead className="text-[#5B9BD5]">Rotation Details</TableHead>
                    {formData.razaPackage && <TableHead className="text-[#5B9BD5]">ITS Miqaat ID</TableHead>}
                    <TableHead className="text-[#5B9BD5]">Arrival</TableHead>
                    <TableHead className="text-[#5B9BD5]">Departure</TableHead>
                    <TableHead className="text-[#5B9BD5]">Quota</TableHead>
                    <TableHead className="text-[#5B9BD5] text-right">Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>

                  {rotations.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7} className="text-center py-6 text-gray-500">
                        No Record
                      </TableCell>
                    </TableRow>
                  )}

                  {rotations.map((rotation, index) => {
                    const isExpanded = expandedRotations.includes(rotation.id);
                    const totalAllocated = rotation.tourOperators.reduce((sum, to) => sum + to.allocatedQuota, 0);
                    const remaining = rotation.quota - totalAllocated;

                    return (
                      <Fragment key={rotation.id || index}>
                        <TableRow className="hover:bg-gray-50">
                          <TableCell>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => toggleRotationExpansion(rotation.id)}
                              className="p-0 h-6 w-6"
                            >
                              {isExpanded ? (
                                <ChevronDown className="w-4 h-4 text-gray-600" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-600" />
                              )}
                            </Button>
                          </TableCell>
                          <TableCell>
                            <div>
                              <div className="font-medium text-gray-900">{rotation.rotationName}</div>
                              <div className="text-sm text-gray-500">{rotation.rotationId}</div>
                            </div>
                          </TableCell>
                          {formData.razaPackage && (
                            <TableCell>
                              <Badge className="bg-[#5B9BD5] text-white">{rotation.miqaatId}</Badge>
                            </TableCell>
                          )}
                          <TableCell className="text-sm">
                            {rotation.arrivalDate ? new Date(rotation.arrivalDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-') : '-'}
                          </TableCell>
                          <TableCell className="text-sm">
                            {rotation.departureDate ? new Date(rotation.departureDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-') : '-'}
                          </TableCell>
                          <TableCell>
                            <div className="font-medium text-gray-900">{rotation.quota}</div>
                            <div className="text-xs text-gray-500">
                              Allocated: {totalAllocated} | Remaining: <span className="text-green-600 font-medium">{remaining}</span>
                            </div>
                          </TableCell>
                          <TableCell className="text-right">
                            <div className="flex gap-2 justify-end">
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => handleViewHistory(rotation.id)}
                                className="h-7 w-7 p-0 hover:bg-blue-50"
                                style={{ color: '#9333ea' }}

                              >
                                <Activity className="w-3.5 h-3.5" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => openRotationDialog(rotation, 'edit-rotation')}
                                className="text-[#5B9BD5] hover:bg-blue-50 h-8"
                              >
                                <Edit2 className="w-4 h-4" />
                              </Button>
                              {/* <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleDeleteRotation(rotation.id)}
                                className="text-red-600 hover:bg-red-50 h-8"
                                disabled={rotations.length === 1}
                              >
                                <Trash2 className="w-4 h-4" />
                              </Button> */}
                            </div>
                          </TableCell>
                        </TableRow>

                        {/* Expanded Section for Tour Operators */}
                        {isExpanded && (
                          <TableRow>
                            <TableCell colSpan={7} className="bg-gray-50 p-0">
                              <div className="p-4">
                                <div className="flex items-center justify-between mb-3 gap-2">
                                  <div className="flex items-center gap-2 text-[#5B9BD5]">
                                    <Users className="w-4 h-4 flex-shrink-0" />
                                    <span className="font-medium text-sm sm:text-base">
                                      Allocated Tour Operators ({rotation.tourOperators.length})
                                    </span>
                                  </div>
                                  <Button
                                    size="sm"
                                    style={{ background: '#5B9BD5' }}
                                    className="text-white h-8 flex-shrink-0"
                                    onClick={() => openRotationDialog(rotation, 'add-quota')}
                                  >
                                    <Plus className="w-4 h-4 sm:mr-2" />
                                    <span className="hidden sm:inline">Add Quota</span>
                                  </Button>
                                </div>

                                {rotation.tourOperators.length > 0 ? (
                                  <div className="bg-white border border-gray-200 rounded overflow-x-auto">
                                    <Table>
                                      <TableHeader>
                                        <TableRow className="bg-blue-50/50">
                                          <TableHead className="text-[#5B9BD5]">Tour Operator</TableHead>
                                          <TableHead className="text-[#5B9BD5]">Quota</TableHead>
                                          <TableHead className="text-[#5B9BD5] text-right">Actions</TableHead>
                                        </TableRow>
                                      </TableHeader>
                                      <TableBody>
                                        {rotation.tourOperators.map((to) => (
                                          <TableRow key={to.id} className="hover:bg-gray-50">
                                            <TableCell>
                                              {/* <div className="font-medium">{to.operatorName}</div> */}
                                              <div className="font-medium">{to.office}</div>
                                              {/* <div className="text-sm text-gray-500">{to.office}</div> */}
                                            </TableCell>
                                            <TableCell>
                                              <div className="font-semibold text-gray-900">{to.allocatedQuota}</div>
                                            </TableCell>
                                            <TableCell className="text-right">
                                              <div className="flex items-center justify-end gap-1">
                                                <Button
                                                  variant="ghost"
                                                  size="sm"
                                                  onClick={() => {
                                                    // Open dialog in edit mode for this specific tour operator
                                                    openRotationDialog(rotation, 'add-quota');
                                                    // Set editing state after dialog opens
                                                    setTimeout(() => {
                                                      setSelectedTourOperatorId(to.operatorId);
                                                      setAllocatedQuota(to.allocatedQuota);
                                                      setEditingQuotaId(to.id);
                                                    }, 0);
                                                  }}
                                                  className="text-[#5B9BD5] hover:bg-blue-50 h-8"
                                                  title="Edit quota"
                                                >
                                                  <Edit2 className="w-4 h-4" />
                                                </Button>
                                                {/* <Button
                                                  variant="ghost"
                                                  size="sm"
                                                  onClick={() => setDeleteConfirmDialog({
                                                    open: true,
                                                    type: 'tour-operator',
                                                    id: to.id,
                                                    rotationId: rotation.id,
                                                    name: to.operatorName,
                                                  })}
                                                  className="text-red-600 hover:bg-red-50 h-8"
                                                  title="Delete"
                                                >
                                                  <Trash2 className="w-4 h-4" />
                                                </Button> */}
                                              </div>
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </div>
                                ) : (
                                  <div className="text-center py-6 bg-white border border-dashed border-gray-300 rounded">
                                    <p className="text-sm text-gray-500">No tour operators assigned yet</p>
                                  </div>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </div>

            {/* Rotations Mobile View */}
            <div className="lg:hidden space-y-3">
              {rotations.map((rotation) => {
                const isExpanded = expandedRotations.includes(rotation.id);
                const totalAllocated = rotation.tourOperators.reduce((sum, to) => sum + to.allocatedQuota, 0);
                const remaining = rotation.quota - totalAllocated;

                return (
                  <div key={rotation.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                    <div className="p-4 space-y-3">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <div className="font-semibold text-gray-900">{rotation.rotationName}</div>
                          <div className="text-sm text-gray-500">{rotation.rotationId}</div>
                          {formData.razaPackage && (
                            <Badge className="bg-[#5B9BD5] text-white mt-1">{rotation.miqaatId}</Badge>
                          )}
                        </div>
                        <div className="flex gap-1">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => openRotationDialog(rotation, 'edit-rotation')}
                            className="text-[#5B9BD5] hover:bg-blue-50 h-8 w-8 p-0"
                          >
                            <Edit2 className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="ghost"
                            size="sm"
                            className="text-red-600 hover:bg-red-50 h-8 w-8 p-0"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-2 text-sm">
                        <div>
                          <span className="text-gray-500">Arrival:</span>
                          <div className="font-medium">
                            {rotation.arrivalDate ? new Date(rotation.arrivalDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-') : '-'}
                          </div>
                        </div>
                        <div>
                          <span className="text-gray-500">Departure:</span>
                          <div className="font-medium">
                            {rotation.departureDate ? new Date(rotation.departureDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-') : '-'}
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center justify-between bg-gray-50 rounded p-2">
                        <div>
                          <span className="text-xs text-gray-500">Quota:</span>
                          <span className="ml-2 font-semibold text-gray-900">{rotation.quota}</span>
                        </div>
                        <div className="text-xs">
                          <span className="text-gray-500">Allocated:</span>
                          <span className="ml-1 font-medium">{totalAllocated}</span>
                          <span className="mx-1">|</span>
                          <span className="text-gray-500">Remaining:</span>
                          <span className="ml-1 font-medium text-green-600">{remaining}</span>
                        </div>
                      </div>

                      <div className="flex items-center justify-between border-t pt-3">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => toggleRotationExpansion(rotation.id)}
                          className="text-[#5B9BD5] h-8 px-2"
                        >
                          {isExpanded ? <ChevronDown className="w-4 h-4 mr-1" /> : <ChevronRight className="w-4 h-4 mr-1" />}
                          <Users className="w-4 h-4 mr-2" />
                          Tour Operators ({rotation.tourOperators.length})
                        </Button>
                        <Button
                          size="sm"
                          style={{ background: '#5B9BD5' }}
                          className="text-white h-8"
                          onClick={() => openRotationDialog(rotation, 'add-quota')}
                        >
                          <Plus className="w-4 h-4 mr-1" />
                          Add Quota
                        </Button>
                      </div>

                      {isExpanded && rotation.tourOperators.length > 0 && (
                        <div className="border-t pt-3 space-y-2">
                          {rotation.tourOperators.map((to) => (
                            <div key={to.id} className="bg-gray-50 rounded p-3 flex justify-between items-center">
                              <div>
                                {/* <div className="font-medium text-sm">{to.operatorName}</div> */}
                                <div className="font-medium text-sm text-gray-500">{to.office}</div>
                              </div>
                              <div className="flex items-center gap-2">
                                <div className="text-right">
                                  <div className="text-sm font-semibold">{to.allocatedQuota}</div>
                                  <div className="text-xs text-gray-500">quota</div>
                                </div>

                                <Button
                                  variant="ghost"
                                  size="sm"
                                  onClick={() => {
                                    // Open dialog in edit mode for this specific tour operator
                                    openRotationDialog(rotation, 'add-quota');
                                    // Set editing state after dialog opens
                                    setTimeout(() => {
                                      setSelectedTourOperatorId(to.operatorId);
                                      setAllocatedQuota(to.allocatedQuota);
                                      setEditingQuotaId(to.id);
                                    }, 0);
                                  }}
                                  className="text-[#5B9BD5] hover:bg-blue-50 h-8"
                                  title="Edit quota"
                                >
                                  <Edit2 className="w-4 h-4" />
                                </Button>
                                {/* <Button
                                  variant="ghost"
                                  size="sm"
                                  onClick={() => setDeleteConfirmDialog({
                                    open: true,
                                    type: 'tour-operator',
                                    id: to.id,
                                    rotationId: rotation.id,
                                    name: to.operatorName,
                                  })}
                                  className="text-red-600 hover:bg-red-50 h-8 w-8 p-0"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {isExpanded && rotation.tourOperators.length === 0 && (
                        <div className="border-t pt-3 text-center py-4 bg-gray-50 rounded">
                          <p className="text-sm text-gray-500">No tour operators assigned yet</p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Edit Rotation / Add Quota Dialog */}
      <Dialog open={showRotationDialog}
        // onOpenChange={setShowRotationDialog}  
        onOpenChange={(isOpen) => {
          setShowRotationDialog(isOpen);
          if (!isOpen) {
            setEditingRotationId(null);
            resetRotationForm(); // ✅ RESET HERE
            setSelectedTourOperatorId('');
            setTourOperatorError(''); // remove error
            setAllocatedQuota(0);
            setQuotaError('');
            setEditingQuotaId(null);
          }
        }}
      >
        <DialogContent className="bg-white max-w-[95vw] w-full sm:max-w-4xl lg:max-w-5xl xl:max-w-6xl 2xl:max-w-7xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <div>
              <DialogTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2">
                <Calendar className="w-5 h-5" />
                {dialogMode === 'edit-rotation' ? 'Edit Rotation' : 'Add Quota'}
              </DialogTitle>
              <p className="text-sm text-gray-600 mt-1">
                {dialogMode === 'edit-rotation'
                  ? 'Update rotation details and manage tour operator allocations'
                  : 'Manage tour operator allocations for this rotation'}
              </p>
            </div>
          </DialogHeader>
          <div className="space-y-4 py-3">
            {/* Rotation Details Section */}
            <div>
              <div className="flex items-center gap-2 mb-3">
                <Calendar className="w-4 h-4 text-[#5B9BD5]" />
                <h3 className="font-semibold text-gray-900">Rotation Details</h3>
              </div>

              {dialogMode === 'edit-rotation' ? (
                // EDITABLE FIELDS - Edit Rotation Mode
                <div className="space-y-3">
                  {/* Row 1: ITS Miqaat ID (if raza), Rotation ID, Rotation Name */}
                  <div className={`grid gap-3 ${formData.razaPackage ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2'}`}>
                    {formData.razaPackage && (
                      <div className="space-y-1.5">
                        <InputFieldset
                          label="ITS Miqaat ID"
                          required
                          placeholder="GEN"
                          value={rotationForm.miqaatId}
                          onChange={(e) => setRotationForm({ ...rotationForm, miqaatId: e.target.value })}
                          className="bg-white border-gray-300"
                        />
                      </div>
                    )}
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Rotation ID"
                        required
                        placeholder="R-GEN-001"
                        value={rotationForm.rotationId}
                        onChange={(e) => setRotationForm({ ...rotationForm, rotationId: e.target.value })}
                        className="bg-white border-gray-300"
                      />
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Rotation Name"
                        required
                        placeholder="General"
                        value={rotationForm.rotationName}
                        onChange={(e) => setRotationForm({ ...rotationForm, rotationName: e.target.value })}
                        className="bg-white border-gray-300"
                      />
                    </div>
                  </div>

                  {/* Row 2: Arrival Date, Departure Date */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Arrival Date"
                        type="date"
                        value={rotationForm.arrivalDate}
                        onChange={(e) => setRotationForm({ ...rotationForm, arrivalDate: e.target.value })}
                        className="bg-white border-gray-300"
                      />
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Departure Date"
                        type="date"
                        value={rotationForm.departureDate}
                        onChange={(e) => setRotationForm({ ...rotationForm, departureDate: e.target.value })}
                        className="bg-white border-gray-300"
                      />
                    </div>
                  </div>

                  {/* Row 3: Quota, Lawazim */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Quota"
                        required
                        type="text"
                        placeholder="1000"
                        value={rotationForm.quota}
                        onChange={(e) => {
                          const value = allowOnlyNumbers(e.target.value);
                          setRotationForm({ ...rotationForm, quota: parseInt(value) || 0 });
                        }}
                        className="bg-white border-gray-300"
                      />
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Allocated"
                        readOnly
                        type="number"
                        placeholder="1000"
                        value={tempTourOperators.reduce((sum, to) => sum + to.allocatedQuota, 0)}
                        // onChange={(e) => setRotationForm({ ...rotationForm, quota: parseInt(e.target.value) || 0 })}
                        className="bg-white border-gray-300 text-red-500 font-semibold cursor-not-allowed"
                      />
                    </div>
                    <div className="space-y-1.5">
                      <InputFieldset
                        label="Remaining"
                        readOnly
                        type="number"
                        placeholder="1000"
                        value={rotationForm.quota - tempTourOperators.reduce((sum, to) => sum + to.allocatedQuota, 0)}
                        className="bg-white border-gray-300 text-green-500 font-semibold cursor-not-allowed"
                      />
                    </div>
                    <div className="space-y-1.5">
                      <SelectFieldset label="Lawazim" required>
                        <Select
                          // value={rotationForm.lawazimId}
                          value={String(rotationForm.lawazimId || "")}
                          onValueChange={(value) => setRotationForm({ ...rotationForm, lawazimId: value })}>
                          <SelectTriggerUI className="bg-input-background bg-white border-gray-300">
                            <SelectValue placeholder="Select Lawazim" />
                          </SelectTriggerUI>
                          <SelectContent>
                            {available_Lawazim.map((lawazim) => (
                              <SelectItem key={lawazim.id} value={String(lawazim.id)}>
                                {/* {lawazim.lawazimName} ({lawazim.code}) */}
                                {lawazim?.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </SelectFieldset>
                    </div>
                  </div>
                </div>
              ) : (
                // READ-ONLY DISPLAY - Add Quota Mode
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 sm:p-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-3">
                    {formData.razaPackage && (
                      <div>
                        <Label className="text-xs text-gray-500 mb-1 block">ITS Miqaat ID</Label>
                        <p className="text-sm font-medium text-gray-900">{rotationForm.miqaatId || '-'}</p>
                      </div>
                    )}
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Rotation ID</Label>
                      <p className="text-sm font-medium text-gray-900">{rotationForm.rotationId || '-'}</p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Rotation Name</Label>
                      <p className="text-sm font-medium text-gray-900">{rotationForm.rotationName || '-'}</p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Arrival Date</Label>
                      <p className="text-sm font-medium text-gray-900">
                        {rotationForm.arrivalDate
                          ? new Date(rotationForm.arrivalDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-')
                          : '-'}
                      </p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Departure Date</Label>
                      <p className="text-sm font-medium text-gray-900">
                        {rotationForm.departureDate
                          ? new Date(rotationForm.departureDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-')
                          : '-'}
                      </p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Total Quota</Label>
                      <p className="text-sm font-semibold text-[#5B9BD5]">{rotationForm.quota}</p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Lawazim</Label>
                      <p className="text-sm font-medium text-gray-900">
                        {rotationForm.lawazimId
                          ? available_Lawazim.find(l => String(l.id) === String(rotationForm.lawazimId))?.lawazimName || '-'
                          : '-'}
                      </p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Allocated</Label>
                      <p className="text-sm font-semibold text-orange-600">
                        {tempTourOperators.reduce((sum, to) => sum + to.allocatedQuota, 0)}
                      </p>
                    </div>
                    <div>
                      <Label className="text-xs text-gray-500 mb-1 block">Remaining</Label>
                      <p className="text-sm font-semibold text-green-600">
                        {rotationForm.quota - tempTourOperators.reduce((sum, to) => sum + to.allocatedQuota, 0)}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Tour Operators Section */}
            <div className="border-t pt-3">
              <div className="flex items-center justify-between mb-3 gap-2">
                <div className="flex items-center gap-2">
                  <Users className="w-5 h-5 text-[#5B9BD5] flex-shrink-0" />
                  <h3 className="font-semibold text-gray-900 text-sm sm:text-base">Tour Operators for this Rotation</h3>
                </div>
                {/* <Button
                  size="sm"
                  style={{ background: '#5B9BD5' }}
                  className="text-white h-8 flex-shrink-0"
                  type="button"
                >
                  <Plus className="w-4 h-4 sm:mr-2" />
                  <span className="hidden sm:inline">Add Operator</span>
                </Button> */}
              </div>

              {/* Add Tour Operator Form */}
              <div className="bg-gray-50 p-3 rounded border border-gray-200 mb-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="space-y-1.5">
                    <SelectFieldset label="Tour Operator" required>
                      <Popover open={comboboxOpen} onOpenChange={setComboboxOpen}>
                        <PopoverTrigger asChild>
                          <PopoverTriggerUI
                            variant="outline"
                            role="combobox"
                            aria-expanded={comboboxOpen}
                            disabled={!!editingQuotaId}
                            className="h-9 w-full justify-between bg-white border-gray-300 font-normal disabled:opacity-60"
                          >
                            {selectedTourOperatorId
                              ? (() => {
                                // First check in available operators
                                let selected = availableTourOperators.find((op) => String(op.tourOperatorId) === selectedTourOperatorId);
                                // If not found (when editing), check in temp tour operators
                                if (!selected && editingQuotaId) {
                                  const tempOp = tempTourOperators.find((to) => to.operatorId === selectedTourOperatorId);
                                  if (tempOp) {
                                    selected = {
                                      tourOperatorId: Number(tempOp.operatorId),
                                      firstName: tempOp.operatorName, // fallback
                                      lastName: "",
                                      officeName: tempOp.office,
                                      itsNumber: tempOp.itsNumber,
                                      mobileNumber: "",
                                      businessType: "",
                                      countryId: 0,
                                      cityId: "",
                                      status: null,
                                    };
                                  }
                                }
                                return selected ? `${selected.officeName}` : 'Select tour operator';
                                // return selected ? `${selected.firstName} - ${selected.officeName} (${selected.itsNumber})` : 'Select tour operator';
                              })()
                              : 'Select tour operator'}
                            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                          </PopoverTriggerUI>
                        </PopoverTrigger>
                        <PopoverContent className="w-[90vw] sm:w-[400px] p-0">
                          <Command>
                            <CommandInput placeholder="Search by name, office, or ITS number..." className="h-9 focus:outline-none focus:ring-0 focus:border-transparent" />
                            <CommandEmpty>No tour operator found.</CommandEmpty>
                            <CommandGroup className="max-h-64 overflow-auto">
                              {availableTourOperators.map((op, i) => (
                                <CommandItem
                                  key={op.id || i}
                                  // value={`${op.firstName} ${op.officeName} ${op.itsNumber}`}
                                  value={`${op.officeName}`}
                                  onSelect={() => {
                                    setSelectedTourOperatorId(String(op.tourOperatorId));
                                    setTourOperatorError(''); // remove error
                                    setComboboxOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedTourOperatorId === String(op.tourOperatorId) ? 'opacity-100' : 'opacity-0'}`}
                                  />
                                  <div className="flex flex-col">
                                    {/* <span className="font-medium">{op.firstName}</span> */}
                                    <span className="font-medium">{op.officeName}</span>
                                    {/* <span className="font-medium">{op.firstName}</span> */}
                                    {/* <span className="text-xs text-gray-500">{op.officeName} • ITS: {op.itsNumber}</span> */}
                                  </div>
                                </CommandItem>
                              ))}
                            </CommandGroup>
                          </Command>
                        </PopoverContent>
                      </Popover>
                    </SelectFieldset>
                    {tourOperatorError && (
                      <p className="text-red-500 text-xs">{tourOperatorError}</p>
                    )}
                  </div>
                  <div className="space-y-1.5">
                    <InputFieldset
                      label="Allocated Quota"
                      required
                      type="text"
                      placeholder="0"
                      value={allocatedQuota}
                      onChange={(e) => {
                        const value = allowOnlyNumbers(e.target.value);
                        setAllocatedQuota(parseInt(value) || 0);
                        if (String(value) > '0') {
                          setQuotaError('');
                        }
                      }}
                      className="bg-white border-gray-300"
                    />
                    {quotaError && (
                      <p className="text-red-500 text-xs">{quotaError}</p>
                    )}
                  </div>
                </div>
                <div className="flex justify-end gap-2 mt-2">
                  <Button
                    variant="outline"
                    size="sm"
                    type="button"
                    onClick={() => {
                      setSelectedTourOperatorId('');
                      setTourOperatorError(''); // remove error
                      setAllocatedQuota(0);
                      setQuotaError('');
                      setEditingQuotaId(null);
                    }}
                    className="h-8"
                  >
                    {editingQuotaId ? 'Cancel' : 'Clear'}
                  </Button>
                  <Button
                    size="sm"
                    type="button"
                    onClick={handleAddTourOperatorInDialog}
                    style={{ background: '#5B9BD5' }}
                    className="text-white h-8"

                  >
                    <Plus className="w-4 h-4 sm:mr-2" />
                    {editingQuotaId ? 'Update' : 'Add'}
                  </Button>
                </div>
              </div>

              {/* Tour Operators List */}
              {tempTourOperators.length > 0 && (
                <div className="border border-gray-200 rounded overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow className="bg-blue-50">
                        <TableHead className="text-[#5B9BD5]">Tour Operator</TableHead>
                        <TableHead className="text-[#5B9BD5]">Quota</TableHead>
                        <TableHead className="text-[#5B9BD5] text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {tempTourOperators.map((to) => (
                        <TableRow key={to.id} className="hover:bg-gray-50">
                          <TableCell>
                            {/* <div className="font-medium">{to.operatorName}</div> */}
                            <div className="font-medium">{to.office}</div>
                            {/* <div className="text-sm text-gray-500">{to.office}</div> */}
                            {/* <div className="text-sm text-gray-500">{to.office} • ITS: {to.itsNumber}</div> */}
                          </TableCell>
                          <TableCell>
                            <div className="font-semibold text-gray-900">{to.allocatedQuota}</div>
                          </TableCell>
                          <TableCell className="text-right">
                            <div className="flex items-center justify-end gap-1">
                              <Button
                                variant="ghost"
                                size="sm"
                                type="button"
                                onClick={() => {
                                  setSelectedTourOperatorId(to.operatorId);
                                  setAllocatedQuota(to.allocatedQuota);
                                  setEditingQuotaId(to.id);
                                }}
                                className="text-[#5B9BD5] hover:bg-sky-50 h-7 w-7 p-0"
                                title="Edit quota"
                              >
                                <Edit2 className="w-3.5 h-3.5" />
                              </Button>
                              {/* <Button
                                variant="ghost"
                                size="sm"
                                type="button"
                                onClick={() => handleRemoveTourOperatorFromDialog(to.id)}
                                className="text-red-600 hover:bg-red-50 h-7 w-7 p-0"
                                title="Remove"
                              >
                                <Trash2 className="w-3.5 h-3.5" />
                              </Button> */}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </div>
          </div>
          <DialogFooter className="flex-col sm:flex-row gap-2">
            {dialogMode === 'edit-rotation' ? (
              <>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowRotationDialog(false);
                    setEditingRotationId(null);
                    // ✅ Reset Rotation form
                    resetRotationForm()
                    setSelectedTourOperatorId('');
                    setTourOperatorError(''); // remove error
                    setAllocatedQuota(0);
                    setQuotaError('');
                    setEditingQuotaId(null);
                  }}
                  className="h-9 w-full sm:w-auto"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSaveRotation}
                  style={{ background: '#5B9BD5' }}
                  className="text-white h-9 w-full sm:w-auto"
                >
                  Save Changes
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowRotationDialog(false);
                    setEditingRotationId(null);
                    // ✅ Reset Rotation form
                    resetRotationForm()
                    setSelectedTourOperatorId('');
                    setTourOperatorError(''); // remove error
                    setAllocatedQuota(0);
                    setQuotaError('');
                    setEditingQuotaId(null);
                  }}
                  className="h-9 w-full sm:w-auto"
                >
                  Cancel
                </Button>
                {/* <Button
                  onClick={() => {
                    handleSaveRotation();
                  }}
                  style={{ background: '#5B9BD5' }}
                  className="text-white h-9 w-full sm:w-auto"
                >
                  Add Save
                </Button> */}
              </>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>


      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteConfirmDialog.open} onOpenChange={(open) => !open && setDeleteConfirmDialog({ open: false, type: 'lawazim', id: '' })}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="w-5 h-5" />
              Confirm Deletion
            </DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <p className="text-gray-700">
              Are you sure you want to delete{' '}
              {deleteConfirmDialog.type === 'lawazim' ? (
                <span className="font-semibold">lawazim "{deleteConfirmDialog.name}"</span>
              ) : (
                <span className="font-semibold">tour operator "{deleteConfirmDialog.name}"</span>
              )}
              ? This action cannot be undone.
            </p>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setDeleteConfirmDialog({ open: false, type: 'lawazim', id: '' })}
              className="h-9"
            >
              No, Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              className="h-9 bg-red-600 hover:bg-red-700 text-white"
            >
              Yes, Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>


      {/* Activity Logs Dialog */}
      {selectedApplicantForLogs && (
        <ActivityLogsPage
          visaId={selectedApplicantForLogs[0]?.visaApplicationId}
          statushisLoader={statushisLoader}
          selectedApplicantForLogs={selectedApplicantForLogs}
          open={showActivityLogs}
          onClose={() => {
            setShowActivityLogs(false);
            setSelectedApplicantForLogs([]);
          }}
        />
      )}
    </div>
  );
}